import React from 'react';

export default function Notice() {
  return (
    <div className="w-full m-auto mt-16 bg-white shadow-sm lg:w-3/4">
      <div className="pt-16 pb-16 pl-4 pr-4 lg:ml-32 lg:mr-32">
        <h1 className="pt-6 pb-6 text-xl font-semibold"> Important - Beware of scams </h1>
        <hr className="text-gray-400" />
        <p className="pt-6 pb-6 text-sm">
          Beware of immigration fraud or scams. No agent, representative, consultancy, or entity can promise you a visa or Canadian citizenship. Only
          the CIC grants visas or permits based on your applications and background. It doesn't have any connections with the services that people
          offer. Stamped was started with the intention of preventing such scams by offering real solutions to students who need help. We do this by
          offering - Information in uncomplicated language for non-native speakers. simple steps, editable templates and free tools. Stamped does not
          represent you or advise you on immigration or citizenship matters. Do not pay anyone to represent you unless they're authorized by the CIC.
          The Canadian government has a very specific list of professionals who are authorized to represent you. Beware of false representatives, fake
          government websites or any unauthorized advice on immigration or citizenship.
        </p>
      </div>
    </div>
  );
}
